import { render, staticRenderFns } from "./SmallPupilOptometry.vue?vue&type=template&id=2a41f30c&scoped=true&"
import script from "./SmallPupilOptometry.vue?vue&type=script&lang=js&"
export * from "./SmallPupilOptometry.vue?vue&type=script&lang=js&"
import style0 from "./SmallPupilOptometry.vue?vue&type=style&index=0&id=2a41f30c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a41f30c",
  null
  
)

export default component.exports